///////////////////////////////////////////////////////////////////////////////
import Helper from '../helper/helper'
import leftMenuVdsina from './client-left-menu-vdsina'
import leftMenuVdsinaCom from './client-left-menu-vdsina-com'
import leftMenuMacloud from './client-left-menu-macloud'

const leftMenu = () => {
	if (process.env.APP_NAME === 'macloud') return leftMenuMacloud
	if (process.env.APP_NAME === 'vdsina.com') return leftMenuVdsinaCom
	return leftMenuVdsina
}

///////////////////////////////////////////////////////////////////////////////
const clientData = {
	//=========================================================================
	// левое меню
	//=========================================================================
	leftMenu: leftMenu(),

	//=========================================================================
	// VDS
	//=========================================================================
	'vds': {
		// название модели
		'model': 'ServiceSearch',
		// настройки для CRUD LIST
		'list': {
			// доступные верхние кнокпи
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'service/create_vds'
			},
			// колонка с ID каждой записи
			'column_id': 'service_id',
			// достпуные фильтры
			'filters': {
				'radio': {
					'plan_group_id': 'plangroup/plangroup'
				},
				// фильтр-switcher
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			// колонки таблицы
			'columns': {
				'group': {
					'class-row': 'text-center vertical-align-middle',
					'class-col': 'aw5-vds-column-os text-center',
					'title': 'main/type',
					'component-row': 'imageGroupVds',
					'component-param-title': (row, data) => Helper.vdsGroupImageTitle(row, data),
					'component-param-url': (row) => Helper.vdsGroupImage(row)
				},
				'os': {
					'title': 'template/os',
					'style-col': 'width: 50px',
					'class-row': 'text-center vertical-align-middle',
					'class-col': 'text-center',
					'component-row': 'image',
					'component-param-url': (row) => Helper.cellValueFromServiceData('template:image', row)
				},
				'vds': {
					'title': 'service/service',
					'component-row': 'vds_info',
					'component-param-data': (row) => Helper.cellValueFromServiceData('plan:data', row),
					'component-param-flag': (row) => Helper.cellValueFromServiceData('datacenter:country', row),
					'component-param-flag-name': (row) => Helper.cellValueFromServiceData('datacenter:name', row),
					'component-param-url': (row) => '/vds/view/' + row['service_id'],
					'component-param-statusService': (row) => row['service_status'],
					'component-param-statusServiceText': (row) => row['service_status_text'],
					'component-param-text': (row) => row['service_name']
				},
				'ip': {
					'title': 'ippool/ippool',
					'style-col': 'width: 150px',
					'function-row': (row) => Helper.cellValueFromServiceData('ip:ip', row),
					'function-cell-class': (row) => {
						return Helper.cellValueFromServiceData('ip:ip:active', row) ? '' : 'text-strike'
					}
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 120px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('service_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['service_status']
				},
				'service_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center vds-date',
					'formater-row': 'formater_StrDateOnly'
				}
			},
			// кнокпи операций для каждлой строки
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name',
						'timer': 5
					}
				},
				'request': {
					'title': 'request/history',
					'action': 'func:GoTo:request::service_id'
				},
				'vdsReboot': {
					'title': 'service/reboot',
					'action': 'func:GoToVds:reboot'
				},
				'vdsPlan': {
					'title': 'service/plan_change',
					'action': 'func:GoToVds:plan'
				},
				'vdsReinstall': {
					'title': 'service/reinstall',
					'action': 'func:GoToVds:reinstall'
				},
				'vdsChangePassword': {
					'title': 'service/password_change',
					'action': 'func:GoToVds:password'
				},
				'vdsClone': {
					'title': 'main/clone',
					'action': 'func:vdsClone'/*,
					'accountOnly': 'a66056'*/
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				}
			}
		},
		'hint-link': {
			'create': [
				{
					position: 'before-button',
					title: 'field/hint_ssh_key_before',
					link: process.env.QA_SERVER + '/q/autentifikatsiya-s-pomoshchyu-ssh-klyuchey-i-otklyuchenie-dostupa-po-parolyu',
					afterText: 'field/hint_ssh_key_after',
					showIfField: 'sshkey_id'
				},
				{
					position: 'before-button',
					title: 'field/hint_backup_auto',
					link: process.env.QA_SERVER + '/q/kak-nastroit-rezervnoe-kopirovanie-po-raspisaniyu',
					showIfField: 'backup_auto'
				}
			]
		}
	},

	//=========================================================================
	// DISKS
	//=========================================================================
	'disks': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'service/extdisk_create'
			},
			'on-off': 'services',
			'column_id': 'service_id',
			'filters': {
				'radio': {
					// записывается в формате: field_name: title
					'service_status': 'main/status'
				},
				'diskType': {
					'service_type_id': 'servicetype/servicetype'
				},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_name': {
					'title': 'service/extdisk',
					'class-col': 'aw5-vds-column-vds',
					'component-row': 'backup_name',
					'component-param-flag': (row) => Helper.cellValueFromServiceData('datacenter:country', row),
					'component-param-flag-name': (row) => Helper.cellValueFromServiceData('datacenter:name', row),
					'component-param-url': (row) => `/disks/${row['service_status'] === 'active' ? 'update' : 'view'}/` + row['service_id'],
					'component-param-statusService': (row) => row['service_status'],
					'component-param-statusServiceText': (row) => row['service_status_text'],
					'component-param-text': (row) => row['service_name_full']
				},
				'attached': {
					'title': 'service/extdisk_attached',
					'component-row': 'outer_disk_info'
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 115px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('service_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['service_status']
				},
				'service_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/disks/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'connectOuterDisk': {
					'title': 'main/attach main/disk',
					'action': 'func:connectOuterDisk'
				},
				'ejectOuterDisk': {
					'title': 'main/detach main/disk',
					'action': 'func:ejectOuterDisk'
				},
				'cloneOuterDisk': {
					'title': 'main/clone',
					'action': 'func:cloneOuterDisk'
				},
				'backupOuterDisk': {
					'title': 'service/backup_create',
					'action': 'func:backupOuterDisk'
				},
				'restoreBackupOuterDisk': {
					'title': 'service/backup_restore',
					'action': 'func:restoreBackupOuterDisk'
				},
				'scheduleOuterDisk': {
					'title': 'schedule/create_title',
					'action': 'func:scheduleOuterDisk'
				},
				'scheduleOuterDiskUpdate': {
					'title': 'schedule/update_title',
					'action': 'func:scheduleOuterDisk'
				},
				'request': {
					'title': 'request/history',
					'action': 'func:GoTo:request::service_id'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				}
			}
		},
		'hint-link': {
			'create': [
				{
					position: 'before-button',
					title: 'field/hint_backup_auto',
					link: process.env.QA_SERVER + '/q/kak-nastroit-rezervnoe-kopirovanie-po-raspisaniyu',
					showIfField: 'backup_auto'
				}
			]
		}
	},

	//=========================================================================
	// BACKUPS
	//=========================================================================
	'backups': {
		'model': 'ServiceSearch',
		'list': {
			//'can_select_rows': false,
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'service/backup_create'
			},
			'column_id': 'service_id',
			'filters': {
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'backup_name': {
					'title': 'service/backup',
					'class-col': 'aw5-vds-column-vds',
					'component-row': 'backup_name',
					'component-param-flag': (row) => Helper.cellValueFromServiceData('datacenter:country', row),
					'component-param-flag-name': (row) => Helper.cellValueFromServiceData('datacenter:name', row),
					'component-param-url': (row) => '/backups/view/' + row['service_id'],
					'component-param-statusService': (row) => row['service_status'],
					'component-param-statusServiceText': (row) => row['service_status_text'],
					'component-param-text': (row) => row['service_name_full']
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 115px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('service_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['service_status']
				},
				'service_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'restoreBackup': {
					'title': 'main/restore',
					'action': 'func:restoreBackup'
				},
				'createFromBackup': {
					'title': 'main/create server/server',
					'action': 'func:createFromBackup'
				},
				'createFromBackupOuterDisk': {
					'title': 'service/extdisk_create',
					'action': 'func:createFromBackupOuterDisk'
				},
				'renameBackup': {
					'title': 'service/rename_action',
					'action': 'func:renameBackup'
				},
				'copyToDc': {
					'title': 'main/copy',
					'action': 'func:copyToDc'
				},
				'downloadBackup': {
					'title': 'backup/download_title',
					'action': 'func:downloadBackup'
				},
				'request': {
					'title': 'request/history',
					'action': 'func:GoTo:request::service_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// SSHKEY
	//=========================================================================
	'sshkey': {
		'model': 'SshKeySearch',
		'list': {
			'can_select_rows': false,
			'buttons': {
				'create': 'sshkey/create_title'
			},
			'column_id': 'key_id',
			'columns': {
				'key_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.key_id ? '/sshkey/view/' + row.key_id : ''
				}
			},
			'opers': {
				'update': {
					'action': 'url:/sshkey/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'key_name'
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:sshkey:log_sub'
				}
			}
		},
		'hint-link': {
			'list': {
				position: 'bottom',
				title: 'field/hint_ssh_key_before_client',
				link: process.env.QA_SERVER + '/q/autentifikatsiya-s-pomoshchyu-ssh-klyuchey-i-otklyuchenie-dostupa-po-parolyu'
			}
		}
	},

	//=========================================================================
	// ISO
	//=========================================================================
	'iso': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'service/iso_create'
			},
			'column_id': 'service_id',
			'filters': {
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_name_full': {
					'title': 'service/iso_name',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.service_id ? '/iso/view/' + row.service_id : ''
				},
				'attached': {
					'title': 'service/iso_inserting_data',
					'component-row': 'iso_info'
				},
				'size': {
					'style-col': 'width: 80px',
					'title': 'service/iso_size',
					'function-row': (row, raw) => {
						if (row && row['service_data'] && row['service_data']['iso'] && row['service_data']['iso']['filesize'])
							return row['service_data']['iso']['filesize']
						else
							return 'main/unknown'
					}
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 120px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('service_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['service_status']
				},
				'service_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name',
						'timer': 5
					}
				},
				'connectISOOper': {
					'title': 'service/iso_insert',
					'action': 'func:connectISOOper'
				},
				'ejectISOOper': {
					'title': 'service/iso_eject',
					'action': 'func:ejectISOOper'
				},
				'request': {
					'title': 'request/history',
					'action': 'func:GoTo:request::service_id'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// ADDITIONAL-SERVICES
	//=========================================================================
	'additional-services': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name'
			},
			'column_id': 'service_id',
			'filters': {
				'select': {
					'service_type_id': 'servicetype/servicetype'
				},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_name_full': {
					'title': 'service/service',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.service_id ? '/additional-services/view/' + row.service_id : ''
				},
				'parent_name': {
					'title': 'service/parent',
					'sort': true,
					'style-col': 'width: 200px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.parent_id ? '/service/view/' + row.parent_id : ''
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 120px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('service_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['service_status']
				},
				'service_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name',
						'timer': 5
					}
				},
				'request': {
					'title': 'request/history',
					'action': 'func:GoTo:request::service_id'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// REQUEST
	//=========================================================================
	'request': {
		'list': {
			'can_select_rows': false,
			'fast_search': false,
			'column_id': 'request_id',
			'filters': {
				'period': {
					'begin_field': 'request_date_start',
					'end_field': 'request_date_end'
				},
				// их может быть несколько, поэтому в виде объекта
				'radio': {
					'request_type': 'main/type',
					'request_status': 'main/status'
				},
				'select': {
					'service_type_id': 'servicetype/servicetype'
				}
			},
			'columns': {
				'request_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				},
				'service_name_full': {
					'title': 'service/service',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.service_id ? '/service/view/' + row.service_id : ''
				},
				'request_type_text': {
					'style-col': 'width: 110px',
					'title': 'main/type',
					'function-row': (row, raw) => Helper.cellValue('request_type_text', row, raw, ['lower', 'ftc']),
					'function-cell-class': (row) => {
						let _status = row['request_type']
						let _tmp = String(row['request_type_text']).split('/').pop()
						return 'w5-breaked-text w5-status-color-' + (_tmp !== null && _tmp !== undefined && _tmp !== '' ? _tmp : _status)
					}
				},
				'request_status': {
					'style-col': 'width: 100px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('request_status', row, raw),
					'function-cell-class': (row) => 'w5-breaked-text w5-status-color-' + row['request_status']
				}
			}
		}
	},

	//=========================================================================
	// CERTIFICATE
	//=========================================================================
	'certificate': {
		'model': 'ServiceSearch',
		'list': {
			'column_id': 'service_id',
			'buttons': {
				'bulkDel': 'service_name'/*,
				'create': 'service/cert_create'*/
			},
			'filters': {
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_name_full': {
					'title': 'service/cert_crt',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.service_id ? '/certificate/view/' + row.service_id : ''
				},
				'service_end': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 96px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 120px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('service_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['service_status']
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'request': {
					'title': 'request/history',
					'action': 'func:GoTo:request::service_id'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// DNS
	//=========================================================================
	'dns': {
		'model': 'ServiceSearch',
		'list': {
			'column_id': 'service_id',
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'dns/create_domain'
			},
			'filters': {
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_name_full': {
					'sort': true,
					'title': 'service/service',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.service_id ? '/dns/view/' + row.service_id : '',
					'component-param-statusService': (row) => row['service_status'],
					'component-param-statusServiceText': (row) => row['service_status_text'],
					'domain-online-status': (row) => row && row['service_data'] && row['service_data']['real'] === true
				},
				'service_status': {
					'sort': true,
					'style-col': 'width: 120px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('service_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['service_status']
				}
			},
			'opers': {
				'update': {
					'action': 'url:/dns/view'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'request': {
					'title': 'request/history',
					'action': 'func:GoTo:request::service_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				}
			}
		},
		'hint-link': {
			'list': {
				position: 'bottom',
				title: 'field/hint_ns_servers',
				link: process.env.QA_SERVER + '/q/kakie-ns-servery-ispolzovat'
			},
			'create': {
				position: 'bottom',
				title: 'field/hint_ns_servers',
				link: process.env.QA_SERVER + '/q/kakie-ns-servery-ispolzovat'
			}
		}
	},

	//=========================================================================
	// OPERATION
	//=========================================================================
	'operation': {
		'list': {
			'can_select_rows': false,
			'buttons': {
				'balance': 'operation/replenishment',
				'calculator': 'service/calculator',
				'exportCsv': 'main/export CSV'
			},
			'column_id': 'operation_id',
			'filters': {
				'period': {
					'begin_field': 'operation_date_start',
					'end_field': 'operation_date_end'
				},
				// их может быть несколько, поэтому в виде объекта
				'radio': {
					'operation_purse': 'operation/purse',
					'operation_type': 'main/type',
					'operation_status': 'main/status'
				},
				'select': {
					'payment_id': 'payment/payment'
				}
			},
			'columns': {
				'operation_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 80px',
					'class-row': 'text-right',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.operation_id ? '/operation/view/' + row.operation_id : ''
				},
				'operation_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 100px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateHM'
				},
				'operation_summa': {
					'sort': true,
					'style-col': 'width: 90px',
					'class-col': 'text-right',
					'class-row': 'text-right font-weight-500',
					'component-row': 'formated_number',
					'component-param-cell': (row, digits) => {
						if (!row || !('operation_summa' in row) || row['operation_summa'] === null || row['operation_summa'] === undefined)
							return ''
						if (!row || !('operation_type' in row) || row['operation_type'] === null || row['operation_type'] === undefined)
							return row['operation_summa']
						return row['operation_type'] === 1 ? '+' + Helper.FormatMoney2(row['operation_summa'], 2) : '-' + Helper.FormatMoney2(row['operation_summa'], 2)
					}
				},
				'operation_purse': {
					'sort': true,
					'style-col': 'width: 80px',
					'function-row': (row, raw) => Helper.cellValueFromList('operation_purse', row, raw, ['ftc']),
					'function-cell-class': (row) => 'w5-operation-purse'
				},
				'payment_id': {
					'sort': true,
					'title': 'payment/details',
					'component-row': 'linkComponent',
					'component-param-text': (row, raw) => Helper.cellOperationPayment_Text(row, raw),
					'component-param-url': (row, raw) => Helper.cellOperationPayment_Url(row, raw)
				},
				'operation_status': {
					'sort': true,
					'style-col': 'width: 90px',
					/*
					'function-row': (row, raw) => Helper.cellValueFromList('operation_status', row, raw, ['lower', 'ftc']),
					'function-cell-class': (row) => 'w5-status-color-' + row['operation_status']
					*/
					'component-row': 'operation_status',
					'component-param-data': (row, raw) => Helper.cellValueFromList('operation_status', row, raw, ['lower', 'ftc']),
					'component-param-cell-class': (row) => 'w5-breaked-text w5-status-color-' + row['operation_status']
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'operation_id'
					}
				},
				'paymentLink': {
					'title': 'operation/get_payment_link',
					'action': 'func:showPaymentLink'
				}
			}
		}
	},

	//=========================================================================
	// PAYMENTAUTO
	//=========================================================================
	'paymentauto': {
		'model': 'PaymentAutoSearch',
		'list': {
			'buttons': {
				'create': 'paymentauto/create_title',
				'off': '-saved_name',
				'on': '-saved_name'
			},
			'on-off': 'payments',
			'column_id': 'auto_id',
			'filters': {
				'radio': {
					'auto_status': 'main/status'
				}
			},
			'columns': {
				'saved_image': {
					'title': 'main/type',
					'style-col': 'width: 60px',
					'class-row': 'text-center vertical-align-middle xs-img',
					'class-col': 'text-center',
					'component-row': 'image',
					'component-param-url': (row) => Helper.makeUrlForApi(row.saved_image)
				},
				'saved_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.auto_id ? '/paymentauto/update/' + row.auto_id : ''
				},
				'auto_status': {
					'sort': true,
					'style-col': 'width: 100px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('auto_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['auto_status']
				}
			},
			'opers': {
				'update': {
					'action': 'url:/paymentauto/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'saved_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:paymentauto:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// DOCUMENT
	//=========================================================================
	'document': {
		'model': 'DocumentSearch',
		'list': {
			'buttons': {
				'create': 'document/create_title'
			},
			'column_id': 'document_id',
			'filters': {
				'period': {
					'begin_field': 'doc_date_start',
					'end_field': 'doc_date_end'
				},
				'radio': {
					'document_status': 'main/status',
					'document_type': 'main/type'
				},
				'select': {
					'payer_id': 'payer/payer'
				}
			},
			'columns': {
				'document_name': {
					'sort': true,
					'component-row': 'document_html'
				},
				'document_status': {
					'sort': true,
					'style-col': 'width: 80px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('document_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['document_status']
				},
				'document_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'document_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 80px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				}
			},
			'opers': {
				'operLink': {
					'title': 'operation/operation',
					'action': 'func:goOperLink'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:document:log_sub'
				},
				'pdfLink': {
					'title': 'main/download PDF',
					'action': 'func:goPdfLink'
				}
			}
		}
	},

	//=========================================================================
	// PAYER
	//=========================================================================
	'payer': {
		'model': 'PayerSearch',
		'list': {
			'buttons': {
				'create': 'payer/create_title'
			},
			'column_id': 'payer_id',
			'filters': {
				'period': {
					'begin_field': 'payer_date_start',
					'end_field': 'payer_date_end'
				},
				'radio': {
					'payer_status': 'main/status'
				}
			},
			'columns': {
				'payer_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 60px',
					'class-row': 'text-right'
				},
				'payer_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.payer_id ? '/payer/view/' + row.payer_id : ''
				},
				'payer_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly'
				},
				'payer_status': {
					'sort': true,
					'style-col': 'width: 115px',
					'component-row': 'status_info',
					'function-row': (row, raw) => Helper.cellStatus('payer_status', row, raw),
					'function-cell-class': (row) => 'w5-status-color-' + row['payer_status']
				}
			},
			'opers': {
				'update': {
					'action': 'url:/payer/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'payer_name',
						'timer': 5
					}
				},
				'operation': {
					'title': 'operation/operations',
					'action': 'func:GoTo:operation::payer_id'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:payer:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// PARTNER
	//=========================================================================
	'partner': {
		'list': {
			'can_select_rows': false,
			'buttons': {
				'transfer': 'operation/convert'
			},
			'fast_search': false,
			'column_id': 'p2a_id',
			'columns': {
				'program_name': {
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.program_id ? '/partnerprogram/view/' + row.program_id : ''
				},
				'p2a_code': {
					'sort': false,
					'title': 'partner/code',
					'component-row': 'partner_code'
				}
			},
			'opers': {
				'partnerAction': {
					'title': 'partneractions/title',
					'action': 'func:GoTo:partneractions::program_id'
				}
			}
		}
	},

	//=========================================================================
	// PARTNERACTIONS
	//=========================================================================
	'partneractions': {
		'model': 'PartnerActionsSearch',
		'list': {
			'can_select_rows': false,
			'column_id': 'click_id',
			'filters': {
				'period': {
					'begin_field': 'click_date_start',
					'end_field': 'click_date_end'
				}
			},
			'columns': {
				'created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				},
				'program_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.program_id ? '/partnerprogram/view/' + row.program_id : ''
				},
				'http_referer': {
					'sort': true
				},
				'ip': {
					'sort': true,
					'style-col': 'width: 120px'
				},
				'account_name': {
					'sort': true,
					'style-col': 'width: 120px'
				}
			}
		}
	},

	//=========================================================================
	// TICKET
	//=========================================================================
	'ticket': {
		'list': {
			'can_select_rows': false,
			'buttons': {
				'create': 'ticket/create_title'
			},
			'column_id': 'ticket_id',
			'filters': {
				'period': {
					'begin_field': 'ticket_date_start',
					'end_field': 'ticket_date_end'
				}/*,
				'bool': {
					'title_false': 'ticket/show_closed',
					'title_true': 'ticket/hide_closed',
					'field': 'show_closed'
				}*/
			},
			'columns': {
				'ticket_label': {
					'title': 'ticketmessage/read',
					'style-col': 'width: 30px',
					'component-row': 'ticket_read'
				},
				'ticket_subject': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.ticket_id ? '/ticket/view/' + row.ticket_id : ''
				},
				'ticket_status': {
					'sort': true,
					'style-col': 'width: 110px',
					'function-row': (row, raw) => Helper.cellValueFromList('ticket_status', row, raw, ['lower', 'ftc']),
					'function-cell-class': (row) => 'w5-breaked-text w5-status-color-' + row['ticket_status']
				},
				'ticket_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 110px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateHM'
				}
			}
		}
	},

	//=========================================================================
	// LOGS
	//=========================================================================
	'logs': {
		'list': {
			'can_select_rows': false,
			'column_id': 'log_id',
			'filters': {
				'period': {
					'begin_field': 'log_date_start',
					'end_field': 'log_date_end'
				},
				'logs': {
					'field': 'log_action'
				}
			},
			'columns': {
				'log_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 80px',
					'class-row': 'text-right',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.log_id ? '/logs/view/' + row.log_id : ''
				},
				'log_date': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				},
				'log_action': {
					'sort': true,
					'style-col': 'width: 150px',
					'function-row': (row, listData, ftc) => row && row.log_action_text
						? ftc && typeof ftc === 'function' ? ftc(row.log_action_text) : row.log_action_text
						: '',
					'function-cell-class': (row) => 'w5-breaked-text'
				},
				'log_ip': {
					'sort': true,
					'style-col': 'width: 110px'
				},
				'log_sub': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.object_link ? row.object_link.replace('%ID%', row.object_id) : '',
					'component-param-text': (row) => row && row.object_name ? row.object_name : ''
				},
				'user_email': {
					'sort': true,
					'style-col': 'width: 150px',
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.user_type && row.user_id ? '/' + row.user_type + '/view/' + row.user_id : '',
					'user-online-status': 'user_online'
				}
			}
		}
	},

	//=========================================================================
	// USER
	//=========================================================================
	'user': {
		'list': {
			'fast_search': false,
			'buttons': {
				'create': 'user/create_title',
				'off': '-user_email',
				'on': '-user_email'
			},
			'on-off': 'users',
			'column_id': 'user_id',
			'columns': {
				'user_email': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.user_id ? '/user/view/' + row.user_id : '',
					'user-online-status': 'user_online'
				},
				'user_status': {
					'sort': true,
					'style-col': 'width: 150px',
					'function-row': (row, raw) => Helper.cellUserStatusValue(row, raw, ['lower', 'ftc']),
					'function-cell-class': (row) => 'w5-breaked-text w5-status-color-' + row['user_status']
				},
				'user_full_access': {
					'sort': true,
					'style-col': 'width: 110px',
					'function-row': (row, raw) => row['user_full_access'] === true ? Helper.localeFtc('main/yes') : Helper.localeFtc('main/no'),
					'function-cell-class': (row) => 'w5-user-accesses'
				},
				'user_created': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				}
			},
			'opers': {
				'update': {
					'action': 'url:/user/update'
				},
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'user_email',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:user:log_sub'
				},
				'logOver': {
					'title': 'user/actions',
					'action': 'func:GoTo:logs::user_id'
				}
			}
		}
	},

	//=========================================================================
	// PERSON
	//=========================================================================
	'person': {
		'model': 'PersonSearch',
		'list': {
			'buttons': {
				'create': 'person/create_title'
			},
			'column_id': 'person_id',
			'columns': {
				'person_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 60px',
					'class-row': 'text-right'
				},
				'person_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.person_id ? '/person/update/' + row.person_id : ''
				},
				'person_type': {
					'sort': true,
					'style-col': 'width: 205px',
					'function-row': (row, raw) => Helper.cellValueFromList('person_type', row, raw, ['ftc']),
					'function-cell-class': () => 'w5-breaked-text'
				},
				'person_updated': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 120px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateFormat'
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'person_name',
						'timer': 5
					}
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:person:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// DOMAINS
	//=========================================================================
	'domains': {
		'model': 'ServiceSearch',
		'list': {
			'buttons': {
				'bulkDel': 'service_name',
				'create': 'service/register_domain'
			},
			'column_id': 'service_id',
			'filters': {
				'radio': {
					'service_status': 'main/status'
				},
				'select': {
					'plan_id': 'plan/plan'
				},
				'bool': {
					'title_false': 'service/show_deleted',
					'title_true': 'service/hide_deleted',
					'field': 'show_deleted'
				}
			},
			'columns': {
				'service_id': {
					'sort': true,
					'class-col': 'text-right',
					'style-col': 'width: 65px',
					'class-row': 'text-right'
				},
				'service_name': {
					'sort': true,
					'component-row': 'linkComponent',
					'component-param-url': (row) => row && row.service_id ? '/domains/update/' + row.service_id : '',
					'component-param-statusService': (row) => row['service_status'],
					'component-param-statusServiceText': (row) => row['service_status_text']
				},
				'service_end': {
					'sort': true,
					'class-col': 'text-center',
					'style-col': 'width: 96px',
					'class-row': 'text-center',
					'formater-row': 'formater_StrDateOnly',
					'function-cell-class': (row) => 'service-end-date w5-status-color-' + String(row['service_end_color']).toLowerCase()
				}
			},
			'opers': {
				'delete': {
					'action': 'func:deleteCrudObject',
					'dialog': {
						'header': 'main/deleting',
						'body': 'main/delete_msg',
						'name': 'service_name_full',
						'timer': 5
					}
				},
				'request': {
					'title': 'request/history',
					'action': 'func:GoTo:request::service_id'
				},
				'prolong': {
					'title': 'service/prolong',
					'action': 'func:prolongService'
				},
				'log': {
					'title': 'logs/button',
					'action': 'func:GoTo:logs:service:log_sub'
				}
			}
		}
	},

	//=========================================================================
	// Массив размеров страниц
	//=========================================================================
	'pageSizes': [10, 20, 50, 100]
}
///////////////////////////////////////////////////////////////////////////////
export default clientData
///////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// ./src/store/client.js